export const TOMO_INDICATORS = ['partnerId', 'partnerCode'];
